import { Box, CircularProgress } from '@mui/material'
import { FlexRow, useAsyncEffect } from '@xylabs/sdk-react'
import { Buffer } from 'buffer/'
import { useContext, useState } from 'react'

import { EditImageDialog } from '../../../Components'
import { AuthenticationContext, EthersContext, useGeotoken, useGeotokenSettings } from '../../../Contexts'
import { Property } from '../../Property'

const ImageProperty: React.FC = () => {
  const { localAddress, showConnectWalletDialog } = useContext(EthersContext)
  const { auth } = useContext(AuthenticationContext)
  const geotoken = useGeotoken()
  const settings = useGeotokenSettings()

  const [isOwner, setIsOwner] = useState<boolean | null>()
  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      const owner = await geotoken?.getOwner()
      const data = owner && localAddress && owner?.toHex() === localAddress?.toHex()
      if (!isMounted()) return
      setIsOwner(data)
    },
    [geotoken, localAddress],
  )

  const [editingImage, setEditingImage] = useState(false)

  const imageUrl = settings?.data?.image ? `https://image.world.xyo.network/${settings?.data?.image}` : undefined

  const onSaveImage = async (cid: string, bytes: Buffer) => {
    if (settings && auth?.authenticated()) {
      settings.data = { ...settings.data, files: [bytes], image: cid }
      await settings.save()
      setEditingImage(false)
    }
  }

  const onEditClick = async () => {
    if (auth?.authenticated()) {
      setEditingImage(true)
    } else if (auth) {
      if (await auth?.signIn?.()) {
        setEditingImage(true)
      }
    } else {
      showConnectWalletDialog?.()
    }
  }

  return (
    <Property
      actions={[{ disabled: !isOwner, name: 'Change', onClick: onEditClick }]}
      tip={isOwner ? 'This image must be square and 512px by 512px.  It is required for your message to be visible to users.' : undefined}
      title="Image"
      value={imageUrl ?? (settings ? null : undefined)}
    >
      {settings?.data ? (
        <FlexRow paper margin={1}>
          {imageUrl ? <img alt="Geotoken" height={64} src={imageUrl} width={64} /> : <Box height={64} />}
        </FlexRow>
      ) : (
        <CircularProgress size={24} />
      )}
      <EditImageDialog onCancel={() => setEditingImage(false)} onSave={onSaveImage} open={editingImage} />
    </Property>
  )
}

export default ImageProperty
